<template>
	<div>
		<PageHeader
			:data="{
				name: route,
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>

		<div v-if="!error" class="row mb-3">
			<!-- Filters -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2"><font-awesome-icon :icon="['fas', 'filter']" class="text-primary me-1" /> Filters</h4>
								<button v-if="Object.values(this.params).length > 4 && searchActive === ''" @click="clearFilters()" class="btn btn-sm btn-danger text-white me-2">
									Clear
									<font-awesome-icon :icon="['fas', 'times']" />
								</button>
								<button v-if="!searchSaving && haveParamsToSave() && searchActive === ''" @click="searchSaving = true" class="btn btn-sm btn-primary">
									Save search
								</button>
								<div v-if="searchSaving && searchActive === ''" class="save-search d-flex">
									<form @submit.prevent="storeSearch" class="d-flex">
										<input type="text" v-model="searchName" class="form-control form-control-sm ms-2" placeholder="enter search name" required />
										<button type="submit" class="btn btn-sm btn-primary ms-1">
											Save
										</button>
										<a role="button" @click="searchSaving = false" class="btn btn-sm ms-1">
											Cancel
										</a>
									</form>
								</div>
								<span v-if="searchActive !== ''" class="badge bg-success"
									>{{ searchActive }} <font-awesome-icon role="button" @click="clearFilters()" class="ms-2" :icon="['fas', 'times']"
								/></span>
							</div>
							<div class="action-buttons">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasSearches"
									aria-controls="offcanvasSearches"
									class="btn btn-outline-secondary btn-sm me-2"
								>
									Saved Searches <font-awesome-icon :icon="['fas', 'save']" class="me-1" />
								</button>
							</div>
						</div>

						<LPDataTableFilters :filters="table.filters" v-on:getFilters="getFilters($event.filters)" />
					</div>
				</div>
			</div>
			<!-- Table data -->
			<div class="col-12 mb-2">
				<div class="card">
					<div class="card-body">
						<div class="d-flex justify-content-between align-items-center">
							<div class="header d-flex align-items-center">
								<h4 class="p-0 m-0 me-2 text-capitalize">{{ model }}</h4>
								<button
									v-if="authUser.permissions.includes('CARNIVORE_CREATE')"
									data-bs-toggle="modal"
									data-bs-target="#carnivoreModal"
									class="btn btn-primary btn-sm me-2"
								>
									Custom carnivore <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" />
								</button>
							</div>

							<div class="action-buttons">
								<button data-bs-toggle="offcanvas" data-bs-target="#offcanvasTableSettings" aria-controls="offcanvasTableSettings" class="btn btn-secondary btn-sm">
									Settings
								</button>
							</div>
						</div>
						<table :class="!loading && tableData.length > 0 ? 'table table-hover' : 'table table-hover loading'">
							<LPDataTableThead :thead="table.columns" :userColumns="userColumns" v-on:setOrder="setOrderBy($event.orderBy, $event.direction)" />
							<LPDataTableTbody
								:userColumns="userColumns"
								:authUser="authUser"
								:data="tableData"
								:tbody="table.columns"
								:model="model"
								:route="route"
								v-on:deleted="getTableData"
								:rowInfo="false"
								v-on:showInformationModal="showInformationModal($event)"
							/>
						</table>
						<div v-if="!loading && tableData.length === 0" class="col-md-12 text-center">
							<h4>No data available</h4>
						</div>
						<div v-if="loading && tableData.length === 0" class="d-flex justify-content-center">
							<div class="spinner-border" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</div>

						<LPDataTablePagination :pagination="pagination" v-on:getItems="getItems($event.page)" />
					</div>
				</div>
			</div>
		</div>

		<div v-else class="row mb-3">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="alert alert-danger" role="alert">
							{{ error }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for displaying Data -->
		<div class="modal fade" id="dataInfoModal" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-body">
						<div class="d-flex">
							<h2>👨‍💻 {{ dataInfo.name }}</h2>
						</div>
						<div class="text-center py-3">
							<h4>🫵 More info coming soon</h4>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" @click="moreDetails()" class="btn btn-info">More details</button>
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for creating carnivore -->
		<div class="modal fade" id="carnivoreModal" tabindex="-1" aria-labelledby="carnivoreModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<form @submit.prevent="createCarnivore">
						<div class="modal-header">
							<div class="d-flex justify-content-start align-items-center">
								<h5 class="modal-title me-2">Create Custom Carnivore</h5>
								<a href="javascript:void(0)" @click="addCustomMunicipalities = false" class="btn btn-primary btn-sm" v-if="addCustomMunicipalities">Back</a>
							</div>

							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body mb-0">
							<template v-if="!addCustomMunicipalities">
								<div class="alert alert-warning alert-dismissible">
									<button type="button" class="btn-close" data-bs-dismiss="alert"></button>
									⚠️ This is only for creating custom Carnivores, to create regular please go on municipalities page
								</div>

								<div class="form-group mb-1">
									<label for="">Carnivore Name</label>
									<div class="input-group mb-3">
										<input type="text" class="form-control" placeholder="Carnivore name" v-model="newCarnivore.name" required />
									</div>
								</div>

								<div class="form-group mb-1">
									<label for="">Description</label>
									<div class="input-group mb-3">
										<textarea class="form-control" placeholder="Carnivore description" v-model="newCarnivore.description" />
									</div>
								</div>

								<div class="form-group mb-1">
									<label for="">Priority</label>
									<select class="form-select" v-model="newCarnivore.priority">
										<option value="normal">Normal</option>
										<option value="medium">Medium</option>
										<option value="high">High</option>
									</select>
								</div>

								<div class="row mt-2">
									<div class="col-md-12">
										Chose fields for campaigns
									</div>
									<div class="col-md-6" v-for="field in newCarnivore.fields" :key="field.name">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="field.active" :id="field.name" />
											<label class="form-check-label" :for="field.name">
												{{ field.label }}
											</label>
										</div>
									</div>
								</div>
							</template>

							<!-- Add custom municipalities -->
							<div>
								<small v-if="!addCustomMunicipalities">👋 You need to add municipalities for carnivore</small>
								<a
									href="javascript:void(0)"
									class="btn btn-primary d-flex justify-content-center align-items-center"
									@click="addCustomMunicipalities = true"
									v-if="!addCustomMunicipalities"
									>Add municipalities</a
								>
								<template v-if="addCustomMunicipalities">
									<h5>Add municipalities for carnivore</h5>
									<!-- Select municipality if missing for type municipality -->
									<MunicipalityAdvancedSearch class="mb-2" :enableCsvUploadSearch="true" v-on:setMunicipality="addMunicipalityToCarnivore" />

									<div v-if="customMunicipalities.length > 0" style="max-height: 300px; overflow-y: auto;">
										<table class="table">
											<thead>
												<tr>
													<th>Name</th>
													<th>County</th>
													<th>State</th>
													<th>Population</th>
													<th width="30"></th>
												</tr>
											</thead>
											<tbody>
												<tr :key="municipality.id" v-for="municipality in customMunicipalities">
													<td>{{ municipality.full_name }}</td>
													<td>{{ municipality.county }}</td>
													<td>{{ municipality.state }}</td>
													<td>{{ municipality.population }}</td>
													<th width="30">
														<a href="javascript:void(0)" @click="removeFromMunicipality(municipality.id)" class="btn btn-sm btn-danger text-white">
															<font-awesome-icon :icon="['fas', 'times']" />
														</a>
													</th>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="mt-2">
										<span class="badge badge-primary bg-success w-100 py-3 mt-3"
											><h4 class="m-0 p-0">{{ customMunicipalities.length }} municipalities</h4></span
										>
									</div>
								</template>
							</div>
						</div>
						<div class="modal-footer">
							<button v-if="!creatingCarnivoreLoader" type="button" class="btn btn-secondary" data-bs-dismiss="modal">
								Close
							</button>
							<button v-if="!creatingCarnivoreLoader" :disabled="customMunicipalities.length === 0" type="submit" class="btn btn-primary">
								Create
							</button>
							<button v-else class="btn btn-primary" type="button" disabled>
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Loading...
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Offcanvas for Filters -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasFilters" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Filters settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				Filters settings
			</div>
		</div>

		<!-- Offcanvas for Searches -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasSearches" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Saved searches</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Your saved searches</h4>
				<p class="p-0"><small>ℹ️ Click on search to apply search filters to table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'user-searches-' + search.id" v-for="search in searches" class="mb-2 me-1">
							<span
								data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasSearches"
								aria-controls="offcanvasSearches"
								role="button"
								@click="applySearch(search)"
								class="badge bg-success"
								>{{ search.name }}</span
							>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Your saved searches for fast applying filters, you can add important ones to display above table (🚧 coming soon)</small>
			</div>
		</div>

		<!-- Offcanvas for Table Settings -->
		<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasTableSettings" aria-labelledby="offcanvasRightLabel">
			<div class="offcanvas-header">
				<h5 id="offcanvasRightLabel">Table settings</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<h4 class="m-0">Display columns</h4>
				<p class="p-0"><small>ℹ️ Select which columns to display in table</small></p>
				<div class="table-columns-settings">
					<div class="d-flex flex-wrap">
						<div :key="'column-available-' + column" v-for="column in availableColumns" class="mb-2 me-1">
							<span role="button" @click="toggleUserColumn(column)" v-if="userColumns.includes(column)" class="badge bg-success">{{ column }}</span>
							<span role="button" @click="toggleUserColumn(column)" v-else class="badge bg-secondary">{{ column }}</span>
						</div>
					</div>
				</div>

				<small>👨‍🏫 Selected columns are automatically saved to your browser storage and will be used again when you come on this page</small>
				<h4 class="mt-3">Display {{ this.route }} per page</h4>
				<p class="p-0">
					<small>ℹ️ Select how many {{ this.route }} to display per page in table</small>
				</p>
				<div class="form-group w-75">
					<select v-model="userPerPage" @change="setUserPerPage()" class="form-select">
						<option value="10">10 per page</option>
						<option value="15">15 per page</option>
						<option value="20">20 per page</option>
						<option value="30">30 per page</option>
						<option value="50">50 per page</option>
						<option value="100">100 per page</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import { Modal } from 'bootstrap'
import { handleErrors } from '../../actions/helpers'
import LPDataTablePagination from '@/components/lp-data-table/LPDataTablePagination'
import LPDataTableFilters from '@/components/lp-data-table/LPDataTableFilters'
import LPDataTableThead from '@/components/lp-data-table/LPDataTableThead'
import LPDataTableTbody from '@/components/lp-data-table/LPDataTableTbody'
import MunicipalityAdvancedSearch from '@/components/municipality/MunicipalityAdvancedSearch'

export default {
	name: 'Carnivores',
	components: {
		PageHeader,
		LPDataTablePagination,
		LPDataTableFilters,
		LPDataTableThead,
		LPDataTableTbody,
		MunicipalityAdvancedSearch,
	},
	data() {
		return {
			route: 'carnivores',
			model: 'carnivore',
			tableData: [],
			loading: false,
			error: '',
			newTableEntry: {},
			pagination: {},
			page: this.$route.query.page || 1,
			orderBy: this.$route.query.orderBy || 'created_at',
			direction: this.$route.query.direction || 'desc',
			userPerPage: localStorage.getItem('carnivore-per-page') || 20,
			table: {
				columns: [
					{
						name: 'id',
						label: 'ID',
						sort: true,
						type: 'default',
					},
					{
						name: 'name',
						label: 'Name',
						sort: true,
						type: 'default',
					},
					{
						name: 'description',
						label: 'Description',
						sort: true,
						type: 'default',
					},
					{
						name: 'type',
						label: 'Type',
						sort: false,
						type: 'default',
					},
					{
						name: 'campaign_id',
						label: 'Campaign Id',
						sort: false,
						type: 'default',
					},
					{
						name: 'priority',
						label: 'Priority',
						sort: false,
						type: 'default',
					},
					{
						name: 'workers',
						label: 'Workers',
						sort: false,
						type: 'users',
					},
					{
						name: 'status',
						label: 'Status',
						sort: true,
						type: 'custom',
						style: ' <span class="badge badge-primary ms-2 code2">code1</badge>',
						values: [
							{
								name: 'code1',
								type: 'data',
								value: 'status',
							},

							{
								name: 'code2',
								type: 'class',
								value: 'status',
								conditions: [
									{
										value: 'finished',
										replace: 'bg-success',
									},
									{
										value: 'progress',
										replace: 'bg-info',
									},
									{
										value: 'preparing',
										replace: 'bg-warning',
									},
								],
							},
						],
					},
					{
						name: 'municipalities_count',
						label: 'Municipalities count',
						sort: true,
						type: 'default',
					},
					{
						name: 'municipalities',
						label: 'Municipalities',
						sort: false,
						type: 'default',
					},
					{
						name: 'filters',
						label: 'Filters',
						sort: false,
						type: 'default',
					},
					{
						name: 'fields',
						label: 'Fields',
						sort: false,
						type: 'default',
					},
					{
						name: 'created_at',
						label: 'Created',
						sort: false,
						type: 'default',
					},
					{
						name: 'updated_at',
						label: 'Updated',
						sort: false,
						type: 'default',
					},
					{
						name: 'data',
						label: 'Progress',
						sort: false,
						type: 'progress',
					},
					{
						name: 'actions',
						label: 'Actions',
						sort: false,
						type: 'actions',
						width: 145,
						buttons: [
							/* {
								type: 'default',
								label: 'View',
								action: '',
								class: 'btn-secondary',
								permission: 'CARNIVORE_ACCESS',
							}, */
							{
								type: 'work',
								label: 'Work',
								action: '',
								class: 'btn-success',
								permission: 'DATA_ENTRY_WORK',
							},
							{
								type: 'default',
								label: 'Edit',
								action: '',
								class: 'btn-primary',
								permission: 'CARNIVORE_UPDATE',
							},
							{
								type: 'delete',
								label: 'Delete',
								action: '',
								class: 'btn-danger',
								permission: 'CARNIVORE_DELETE',
							},
						],
					},
				],
				filters: [
					{
						display: true,
						name: 'search',
						label: 'Search',
						type: 'text',
						placeholder: 'enter text and press enter',
						colClass: 'col-3',
						value: this.$route.query.search || '',
					},
					{
						display: true,
						name: 'type',
						label: 'Type',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.type || '',
						options: [
							{
								id: 'default',
								name: 'default',
							},
							{
								id: 'campaign',
								name: 'campaign',
							},
						],
					},
					{
						display: true,
						name: 'status',
						label: 'Status',
						type: 'boolean',
						placeholder: 'Select any',
						colClass: 'col-2',
						value: this.$route.query.status || '',
						options: [
							{
								id: 'progress',
								name: 'Progress',
							},
							{
								id: 'finished',
								name: 'Finished',
							},
						],
					},
					{
						display: true,
						name: 'created_at',
						label: 'Created',
						type: 'daterange',
						placeholder: '',
						colClass: 'col-4',
						from: this.$route.query.fromcreated_at || '',
						to: this.$route.query.tocreated_at || '',
					},
				],
			},
			params: {},
			userColumns: JSON.parse(localStorage.getItem(`carnivore-columns`)) || ['name', 'status', 'workers', 'data', 'municipalities_count', 'actions'],
			availableColumns: ['id'],
			searchName: '',
			searchSaving: false,
			searchActive: '',
			searches: [],
			$dataInfoModal: null,
			dataInfo: {},
			$carnivoreModal: null,
			newCarnivore: {
				name: '',
				campaign_id: null,
				type: 'default',
				priority: 'normal',
				description: '',
				workers: null,
				fields: [
					{
						name: 'contacts',
						label: 'Contacts',
						active: true,
						description: '',
						contactTypes: [
							{
								type: '',
								description: '',
								fields: {
									firstName: true,
									lastName: true,
									email: true,
									phone: true,
									title: true
								}
							}
						]
					},
					{
						name: 'email',
						label: 'Email',
						active: true,
						description: ''
					},
					{
						name: 'phone',
						label: 'Phone',
						active: true,
						description: ''
					},
					{
						name: 'county',
						label: 'County',
						active: true,
						description: ''
					},
					{
						name: 'city',
						label: 'City',
						active: true,
						description: ''
					},
					{
						name: 'zip',
						label: 'Zip',
						active: true,
						description: ''
					},
					{
						name: 'address_street',
						label: 'Address street / PO Box',
						active: true,
						description: ''
					},
					{
						name: 'population',
						label: 'Population',
						active: true,
						description: ''
					},
					{
						name: 'issues',
						label: 'Issues',
						active: false,
						description: ''
					},
					{
						name: 'boat_launch',
						label: 'Boat launch',
						active: false,
						description: ''
					},
					{
						name: 'park_rental',
						label: 'Park rental',
						active: false,
						description: ''
					},
					{
						name: 'online_payments',
						label: 'Online payments',
						active: false,
						description: ''
					},
					{
						name: 'fillable_forms',
						label: 'Fillable forms',
						active: false,
						description: ''
					},
					{
						name: 'chat_box',
						label: 'Chat box',
						active: false,
						description: ''
					},
					{
						name: 'alert_notifications',
						label: 'Alert notifications',
						active: false,
						description: ''
					},
					{
						name: 'competitor',
						label: 'Town Web Competitor',
						active: false,
						description: ''
					},
					{
						name: 'competitor_hg',
						label: 'HeyGov Competitor',
						active: false,
						description: ''
					}
				],
				status: 'new',
				data: null,
				filters: '',
				municipalities_count: '',
				municipalities: [],
			},
			carnivoreType: 'filters',
			customMunicipalities: [],
			addCustomMunicipalities: false,
			creatingCarnivoreLoader: false,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
	},
	created() {
		this.table.filters.forEach(filter => {
			if (filter.value && filter.value !== '' && filter.value.length > 0) {
				this.params[filter.name] = filter.value
			} else {
				delete this.params[filter.name]
			}

			if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
				this.params['from' + filter.name] = filter.from
				this.params['to' + filter.name] = filter.to
			} else {
				delete this.params['from' + filter.name]
				delete this.params['to' + filter.name]
			}
		})
		this.getTableColumns()
		this.getTableData(true)
		this.getSearches()
	},
	mounted() {
		this.$dataInfoModal = new Modal('#dataInfoModal')
		this.$carnivoreModal = new Modal('#carnivoreModal')
	},
	methods: {
		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: this.route })
				.then(({ data }) => {
					this.availableColumns = data.map(column => column.name)
					this.availableColumns.push('actions')
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		// Get table data from API
		getTableData(first = false) {
			this.loading = true

			this.params = {
				...this.params,
				page: this.page,
				orderBy: this.orderBy,
				direction: this.direction,
				perPage: localStorage.getItem(`${this.model}-per-page`) || 20,
			}

			restApi
				.get(`/${this.route}`, { params: this.params })
				.then(({ data }) => {
					this.tableData = data.data
					this.pagination = data
					delete this.pagination.data
					this.loading = false
					//this.$router.replace({ query: this.params })
					if (!first) {
						this.$router.push({ path: this.$router.currentPath, query: this.params })
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Go to user page
		viewUser(user) {
			this.$router.push('/users/' + user.id)
		},

		// Get items from page that returned from LPDataTablePagination
		getItems(page) {
			this.page = page
			this.getTableData()
		},

		// Set direction
		setOrderBy(orderBy, direction) {
			this.orderBy = orderBy
			this.direction = direction
			this.getTableData()
		},

		// Get filters from LPDataTableFilters component
		getFilters(filters) {
			this.page = ''
			this.searchActive = ''
			filters.forEach(filter => {
				if (filter.value && filter.value !== '' && filter.value.length > 0) {
					this.params[filter.name] = filter.value
				} else {
					delete this.params[filter.name]
				}

				// Setting filter if its type is range
				if (filter.from && filter.from !== '' && filter.to && filter.to !== '') {
					this.params['from' + filter.name] = filter.from
					this.params['to' + filter.name] = filter.to
				} else {
					delete this.params['from' + filter.name]
					delete this.params['to' + filter.name]
				}
			})
			this.getTableData()
		},

		// Toggle user column
		toggleUserColumn(column) {
			if (this.userColumns.includes(column)) {
				this.userColumns = this.userColumns.filter(c => c !== column)
			} else {
				this.userColumns.push(column)
			}
			this.updateUserColumns()
		},

		// Update user columns
		updateUserColumns() {
			localStorage.setItem(`${this.model}-columns`, JSON.stringify(this.userColumns))
		},

		// Get user saved searches
		getSearches() {
			let params = {
				user_id: this.authUser.id,
				model: this.model,
			}
			restApi
				.get('/searches', { params })
				.then(({ data }) => {
					data.forEach(d => {
						d.data = JSON.parse(d.data)
						return d
					})
					this.searches = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Enable saving if some filters are set
		haveParamsToSave() {
			if (Object.values(this.params).length > 4) {
				return true
			} else {
				return false
			}
		},

		// Get user saved searches
		storeSearch() {
			let dataParams = this.params
			restApi
				.post('/searches', {
					user_id: this.authUser.id,
					model: this.model,
					name: this.searchName,
					data: JSON.stringify(dataParams),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.searches.push(data)
					this.searchActive = this.searchName
					this.searchSaving = false
					this.$swal.fire({
						icon: 'success',
						title: 'Search successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Apply saved search to table
		applySearch(search) {
			// Reset all before applying saved search
			this.params = {}
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'daterange') {
					filter.value = ''
				} else {
					filter.from = ''
					filter.to = ''
				}
			})
			// Apply saved search
			this.params = search.data
			let paramsArray = Object.keys(search.data)
			this.table.filters.forEach(filter => {
				if (paramsArray.includes(filter.name) && filter.type !== 'range') {
					filter.value = this.params[filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'range') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
				if (paramsArray.includes('from' + filter.name) && filter.type === 'daterange') {
					filter.from = this.params['from' + filter.name]
					filter.to = this.params['to' + filter.name]
				}
			})
			this.searchActive = search.name
			this.getTableData()
		},

		// Clear all filters
		clearFilters() {
			this.params = {}
			this.searchActive = ''
			this.table.filters.forEach(filter => {
				if (filter.type !== 'range' && filter.type !== 'multiselect') {
					filter.value = ''
				}
				if (filter.type === 'multiselect') {
					filter.value = []
				}
				if (filter.type === 'range' || filter.type === 'daterange') {
					filter.from = ''
					filter.to = ''
				}
			})
			this.getTableData()
		},

		// Set user per page
		setUserPerPage() {
			localStorage.setItem(`${this.model}-per-page`, this.userPerPage)
			this.getTableData()
		},

		// Sync postcards from LOB
		syncPostcards() {
			this.syncingPostcards = true
			restApi
				.get(`/${this.route}/syncPostcards`)
				.then(() => {
					this.getTableData()
					this.syncingPostcards = false
				})
				.catch(error => {
					this.syncingPostcards = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Sync letters from LOB
		syncLetters() {
			this.syncingLetters = true
			restApi
				.get(`/${this.route}/syncLetters`)
				.then(() => {
					this.getTableData()
					this.syncingLetters = false
				})
				.catch(error => {
					this.syncingLetters = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		showInformationModal(event) {
			restApi
				.get(`/${event.route}/${event.id}`)
				.then(({ data }) => {
					this.dataInfo = data
					this.dataInfo.filters = JSON.parse(data.filters)
					this.dataInfo.printingFilters = []
					this.$dataInfoModal.show()
					for (const property in data.filters) {
						if (property !== 'page' && property !== 'orderBy' && property !== 'direction' && property !== 'perPage') {
							let value = data.filters[property]
							if (value) {
								value === 'Yes'
							}
							if (!value) {
								value === 'No'
							}
							this.dataInfo.printingFilters.push(`${property}: ${value}`)
						}
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
					this.loading = false
				})
		},

		moreDetails() {
			this.$dataInfoModal.hide()
			this.$router.push('/campaigns/edit/' + this.dataInfo.id)
		},

		// Create carnivore
		createCarnivore() {
			this.creatingCarnivoreLoader = true
			let nCarnivore = JSON.parse(JSON.stringify(this.newCarnivore))
			nCarnivore.dataType = 'custom'
			// Store new carnivore
			restApi
				.post(`/carnivores`, nCarnivore)
				.then(() => {
					this.$carnivoreModal.hide()
					this.creatingCarnivoreLoader = false
					this.getTableData()
					this.$swal.fire({
						icon: 'success',
						title: 'Carnivore successfully created!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Add municipalities from MunicipalityAdvancedSearch to array
		addMunicipalityToCarnivore(municipality) {
			if (!this.newCarnivore.municipalities.includes(municipality.id)) {
				this.customMunicipalities.push(municipality)
				this.newCarnivore.municipalities.push(municipality.id)
				this.newCarnivore.municipalities_count = this.newCarnivore.municipalities.length
			}
		},

		// Remove municipality
		removeFromMunicipality(id) {
			this.customMunicipalities = this.customMunicipalities.filter(m => m.id !== id)
			this.newCarnivore.municipalities = this.newCarnivore.municipalities.filter(m => m.id !== id)
			this.newCarnivore.municipalities_count = this.newCarnivore.municipalities.length
		},
	},
}
</script>
